interface SiteChromeOptions {
  siteOrigin: string;
  membersOrigin: string;
}

function absolute(origin: string, path: string): string {
  return new URL(path.replace(/^\//, ""), `${origin.replace(/\/$/, "")}/`).toString();
}

export function initSiteChrome(options: SiteChromeOptions): void {
  document.querySelectorAll<HTMLAnchorElement>("[data-site-path]").forEach((link) => {
    link.href = absolute(options.siteOrigin, link.dataset.sitePath || "");
  });
  document.querySelectorAll<HTMLAnchorElement>("[data-members-link]").forEach((link) => {
    link.href = `${options.membersOrigin.replace(/\/$/, "")}/`;
  });

  const drawer = document.querySelector<HTMLElement>("[data-site-drawer]");
  const overlay = document.querySelector<HTMLElement>("[data-site-overlay]");
  const openButton = document.querySelector<HTMLButtonElement>("[data-site-menu]");
  const closeButton = document.querySelector<HTMLButtonElement>("[data-site-menu-close]");
  if (!drawer || !overlay || !openButton || !closeButton) return;

  let returnFocus: HTMLElement | null = null;
  const close = (): void => {
    drawer.classList.remove("open");
    overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.inert = true;
    openButton.setAttribute("aria-expanded", "false");
    document.body.classList.remove("site-shell-drawer-open");
    returnFocus?.focus();
  };
  const open = (): void => {
    returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : openButton;
    drawer.classList.add("open");
    overlay.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    drawer.inert = false;
    openButton.setAttribute("aria-expanded", "true");
    document.body.classList.add("site-shell-drawer-open");
    closeButton.focus();
  };

  openButton.addEventListener("click", open);
  closeButton.addEventListener("click", close);
  overlay.addEventListener("click", close);
  drawer.querySelectorAll("a").forEach((link) => link.addEventListener("click", close));
  document.addEventListener("keydown", (event) => {
    if (!drawer.classList.contains("open")) return;
    if (event.key === "Escape") {
      close();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = [...drawer.querySelectorAll<HTMLElement>('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}
